import baseAPI from '@/api';
import { QueryFunctionContext } from '@tanstack/react-query';
import { UseBetBySlugQueryKeyProps } from './props';
import { DetailedBet } from '@/models/detailed-bet';
import { AxiosResponse } from 'axios';

export async function fetchBetBySlug({
  queryKey,
}: QueryFunctionContext<UseBetBySlugQueryKeyProps>): Promise<DetailedBet> {
  const slug = queryKey[1];
  const response: AxiosResponse<DetailedBet> = await baseAPI.get<DetailedBet>(
    `/bets/slug/${slug}`,
  );

  return response.data;
}
